var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.token
    ? _c("div", [
        _vm.questionStep
          ? _c("div", [
              _c("span", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("telemedcare.is-first-access")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-4" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "w-100",
                        attrs: { variant: "outline-primary" },
                        on: { click: _vm.showGuidedSteps }
                      },
                      [_vm._v(_vm._s(_vm.$t("yes")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "w-100",
                        attrs: { variant: "outline-primary" },
                        on: {
                          click: function($event) {
                            return _vm.showGuidedSteps($event, true)
                          }
                        }
                      },
                      [_vm._v("No")]
                    )
                  ],
                  1
                )
              ])
            ])
          : _c("div", [
              !_vm.appIsInstalled
                ? _c("div", [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("telemedcare.association.step-1")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "full-center mb-4" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://play.google.com/store/apps/details?id=com.app_tmc&hl=es&gl=US",
                            target: "_blank"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "app-store-btn",
                            attrs: { src: _vm.$t("button.get-on-google-play") }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://apps.apple.com/us/app/tmc-blue/id1549501043?app=itunes&ign-mpt=uo%3D4",
                            target: "_blank"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "app-store-btn",
                            attrs: { src: _vm.$t("button.get-on-app-store") }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("telemedcare.association.step-2", {
                            step: "2"
                          })
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "container full-center mb-4" },
                      [
                        _c("qrcode-vue", {
                          attrs: {
                            size: _vm.size,
                            value: _vm.value,
                            level: "H"
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _c("div", [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("telemedcare.association.step-2-installed", {
                            step: "1"
                          })
                        )
                      }
                    })
                  ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("telemedcare.association.step-3", {
                      step: _vm.appIsInstalled ? "2" : "3"
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("telemedcare.association.step-4", {
                      step: _vm.appIsInstalled ? "3" : "4"
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("telemedcare.association.step-5", {
                      step: _vm.appIsInstalled ? "4" : "5"
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("telemedcare.association.clinic-history")
                  )
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "full-center" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", target: "_blank" },
                      on: {
                        click: function($event) {
                          return _vm.$helpers.goToPatientWebApp("history")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("telemedcare.access-portal")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("p")
            ])
      ])
    : _c(
        "div",
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("telemedcare.no-tmc-token-found")))]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.tmc-modal-login-form",
                      modifiers: { "tmc-modal-login-form": true }
                    }
                  ],
                  attrs: { variant: "primary" }
                },
                [_vm._v(_vm._s(_vm.$t("log-in")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "tmc-modal-login-form",
                centered: "",
                "hide-footer": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "modal-title",
                  fn: function() {
                    return [
                      _vm._v("\n\t\t\t" + _vm._s(_vm.$t("log-in")) + "\n\t\t")
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c("login-form", {
                attrs: {
                  loginUrl: _vm.$helpers.getUrlFromAxiosInstance(
                    _vm.$tmcApi,
                    "Login"
                  ),
                  loginCallback: _vm.loginCallback
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("b-modal")
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be595200", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be595200","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/health/TMCQrCodeContainer.vue
// module id = 3777
// module chunks = 84